<template>
  <div class="media">
    <v-toolbar flat class="d-flex flex-no-wrap align-center justify-end">
      <MediaUploader
        v-on:uploadDone="uploadDone"
        :cropper="true"
        type="image"
        :heigth="600"
        :width="600"
      />
    </v-toolbar>

    <v-container>
      <h1>Media Manager</h1>
      <v-container fluid class="scrolling-container">
        <v-row v-if="files.length > 0">
          <!-- card -->
          <v-col
            class="col-12 col-lg-3"
            v-for="index in files.length"
            :key="index"
            elevation="2"
          >
            <a @click.stop="mediaInfo(index)">
              <v-card>
                <div
                  class="col p-0 m-0"
                  :style="{
                    backgroundImage: `url('${files[index - 1].url}')`,
                    backgroundSize: `cover`,
                    backgroundRepeat: `no-repeat`,
                    backgroundPosition: `center center`,
                    height: `200px`,
                  }"
                ></div>
              </v-card>
            </a>
          </v-col>
          <!-- Card -->
        </v-row>
      </v-container>

      <img src="" alt="" ref="uploadimage" />

      <v-navigation-drawer
        floating
        right
        absolute
        temporary
        v-model="drawer"
        v-if="drawer"
      >
        <v-container
          class="
            drawer-card
            d-flex
            space-between
            flex-column flex-md-row
            align-center
          "
        >
          <v-card flat>
            <div
              class="col p-0 m-0"
              :style="{
                backgroundImage: `url('${files[currentIndex].url}')`,
                backgroundSize: `contain`,
                backgroundRepeat: `no-repeat`,
                backgroundPosition: `center center`,
                height: `50vh`,
                width: `30vw`,
              }"
            ></div>
          </v-card>

          <v-card-text>
            <v-row>
              <v-col cols="12">
                <v-text-field
                  disabled
                  label="Name"
                  v-model="files[currentIndex].name"
                ></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-text-field
                  disabled
                  label="Type"
                  v-model="files[currentIndex].metadata.contentType"
                ></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-text-field
                  disabled
                  label="Date"
                  v-model="files[currentIndex].metadata.timeCreated"
                ></v-text-field>
              </v-col>
              <v-col cols="12" class="d-flex justify-end">
                <v-btn
                  @click="copyClip"
                  type="button"
                  class="btn btn-danger btn-md btn-rounded mr-5"
                >
                  Copy URL
                </v-btn>
                <v-btn
                  @click="deleteImage"
                  type="button"
                  class="btn btn-danger btn-md btn-rounded mr-5"
                >
                  Delete Media
                </v-btn>
                <v-btn
                  @click="mediaInfoExit"
                  type="button"
                  class="btn btn-danger btn-md btn-rounded"
                >
                  Exit
                </v-btn>
              </v-col>
            </v-row>
          </v-card-text>
        </v-container>
      </v-navigation-drawer>
    </v-container>
  </div>
</template>

<script>
/* eslint-disable */
import firebase from "firebase/app";
import "firebase/storage";

export default {
  name: "Media",
  route: {
    path: "/medias/",
    name: "Medias",
  },
  data: () => ({
    drawer: false,
    currentIndex: 0,
    files: [
      {
        name: "",
        url: "",
        metadata: {
          contentType: "",
          timeCreated: "",
        },
      },
    ],
  }),
  components: {
    MediaUploader: () =>
      import("../../components/MediaUploader/MediaUploader.vue"),
  },

  beforeMount() {
    this.getValues();
    // this.getValues2();
  },
  events: {
    reload: function() {
      this.getValues();
    },
  },
  // mounted() {
  //   let self = this;
  //   EventBus.$on("UPLOAD_DONE", function (payLoad) {
  //     self.getValues();
  //   });
  // },
  // unmounted() {
  //   EventBus.$off("UPLOAD_DONE");
  // },
  methods: {
    uploadDone(payload) {
      console.log(payload);
      this.getValues();
    },
    mediaInfoExit() {
      this.drawer = !this.drawer;
    },
    fullscreenImage() {
      this.dialog = !this.dialog;
    },
    mediaInfo(index) {
      this.currentIndex = index - 1;
      this.drawer = !this.drawer;
    },
    copyClip() {
      console.log(this.files[this.currentIndex].url);
      navigator.clipboard.writeText(this.files[this.currentIndex].url);
    },
    deleteImage() {
      let self = this;
      var r = confirm("Delete " + self.files[self.currentIndex].name + "?");
      if (r == true) {
        // Delete the file
        self.files[self.currentIndex]
          .delete()
          .then(() => {
            self.drawer = !self.drawer;
            self.getValues();
          })
          .catch((error) => {
            console.log("// Uh-oh, an error occurred!", error);
          });
      }
    },
    getValues() {
      let self = this;
      self.files = [];

      var storageRef = firebase.storage().ref("medias");
      storageRef
        .listAll()
        .then(function(result) {
          result.items.forEach(function(imageRef) {
            let object = imageRef;
            imageRef
              .getDownloadURL()
              .then(function(url) {
                // TODO: Display the image on the UI
                object.url = `https://storage.googleapis.com/npc-connect.appspot.com/medias/${object.name}`;

                imageRef
                  .getMetadata()
                  .then((metadata) => {
                    object.metadata = metadata;
                    self.files.push(object);

                    // sort by name
                    self.files.sort(function(a, b) {
                      var nameA = a.metadata.timeCreated;
                      var nameB = b.metadata.timeCreated;
                      if (nameA < nameB) {
                        return 1;
                      }
                      if (nameA > nameB) {
                        return -1;
                      }
                      return 0;
                    });
                  })
                  .catch((error) => {
                    console.log(error);
                  });
              })
              .catch(function(error) {
                console.log(error);
              });
          });
        })
        .catch(function(error) {
          console.log(error);
        });
    },
  },
};
</script>

<style lang="scss">
.media {
  .scrolling-container {
    max-height: 90vh;
    overflow: scroll;
  }
  .v-navigation-drawer {
    position: fixed;
    width: 70% !important;
  }
  .v-overlay--active {
    position: fixed;
  }
  .drawer-card {
    height: 100%;
    padding: 10%;
  }
}
</style>
